// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PlanInfoModel {
    'planTerminationDate'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PlanInfoModel>> = [
        {
            "name":     "planTerminationDate",
            "baseName": "planTerminationDate",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PlanInfoModel.attributeTypeMap;
    }
}
